/**
 * Route helpers for campaign views.
 * Selected campaign comes from store/config, not from route params (embed-friendly).
 */

import { campaignOverviewRoute, campaignRoute } from "@/routes";

/**
 * Checks if a pathname is under the campaign section
 */
export const isCampaignRoute = (pathname: string): boolean => {
  return pathname === campaignRoute || pathname.startsWith("/campaign/");
};

/**
 * Whether two pathnames are different campaign sub-routes (same campaign, different tab)
 */
export const isSameCampaignDifferentRoute = (
  pathname1: string,
  pathname2: string
): boolean => {
  return (
    isCampaignRoute(pathname1) &&
    isCampaignRoute(pathname2) &&
    pathname1 !== pathname2
  );
};

/**
 * Campaign nav items (paths only, no :id).
 * `labelKey` is an i18next key resolved at render time via `t(...)`.
 */
export const campaignNavItems = [
  { labelKey: "nav.overview", path: campaignOverviewRoute },
] as const;
